const getRange = (size: number, startAt = 0, step = 1) => [...Array(size).keys()].map(i => i * step + startAt);

export default getRange;
